import React from 'react'
import { useSelector } from 'react-redux'
import { selectWebp } from '../features/ui/uiSlice'

export const Logo = ({ width = 91, height = 91 }) => {
  const isWebp = useSelector(selectWebp)
  return (
    <img
      src={isWebp ? '../assets/fl-logo.webp' : '../assets/fl-logo.png'}
      alt="logo"
      width={width}
      height={height}
    />
  )
}

export const InvertedLogo = ({ width = 62, height = 62 }) => {
  const isWebp = useSelector(selectWebp)
  return (
    <img
      src={
        isWebp
          ? '../assets/converted-logo.webp'
          : '../assets/converted-logo.png'
      }
      alt="logo"
      width={width}
      height={height}
    />
  )
}
